import { MenuCard } from '@runway/devkit';
import { FC } from 'react';

import { useNavigate } from 'react-router-dom';

export const SelfServiceAccessMenu: FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <MenuCard
        title="Batch Ingestion Resource Template"
        subtitle="Batch ingestion resources and framework"
        onButtonClick={() => navigate('../../create/templates/default/dataops')}
        buttonText="REQUEST"
      />
      <MenuCard
        title="Streaming/Database Ingestion Accelerator"
        subtitle="Both Streaming and Ad-hoc/Sandbox database ingestion"
        onButtonClick={() => navigate('../../create/templates/default/deassa')}
        buttonText="REQUEST"
      />
      <MenuCard
        title="DataOps Streaming Ingestion powered by beetles-ingestion"
        subtitle="DataOps Streaming Ingestion provisioning, using the beetles-ingestion library (supports open variant)"
        onButtonClick={() => navigate('../../create/templates/default/dataops_streaming_ingestion')}
        buttonText="REQUEST"
      />
    </>
  );
};
